import {useEffect, useState, useRef} from 'react';

import useScroll from './useScroll';

let silent : boolean;

export const setSilent = (value: boolean) => {
	silent = value;
};

const useScrollThreshold = (positionThreshold: number, updateThreshold: number = 2) => {
	const [isThreshold, setIsThreshold] = useState<boolean>(false);
	const {onScroll, unBind} = useScroll();
	const lastThresholdFlag = useRef(false);
	const lastY = useRef(0);

	const scrollHandler = () => {
		if (silent) {
			lastY.current = window.scrollY;

			return;
		}

		const scrollY = window.scrollY;

		if (
			Math.abs(lastY.current - scrollY) > updateThreshold &&
			lastThresholdFlag.current !== scrollY > positionThreshold
		) {
			lastY.current = scrollY;
			lastThresholdFlag.current = scrollY > positionThreshold;
			setIsThreshold(lastThresholdFlag.current);
		}
	};

	useEffect(() => {
		const currentScrollY = window.scrollY;
		const initialThreshold = currentScrollY > positionThreshold;

		lastY.current = currentScrollY;
		lastThresholdFlag.current = initialThreshold;

		if (initialThreshold) {
			setIsThreshold(true);
		}

		const index = onScroll(scrollHandler);

		return () => unBind(index);
	}, [positionThreshold]);

	return isThreshold;
};

export default useScrollThreshold;
